import { useCallback, useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import UIModal from 'UIComponents/dialog/UIModal';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { EXISTING_USER_FMO_TOUR } from '../../constants/TourConstants';
import { setHasSeenFmoAdminMigrationTour } from '../../actions/DisplayOptionsActions';
import useOverviewModal from '../../hooks/useOverviewModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { SKIP_EXISTING_USER_FMO_TOUR, START_EXISTING_USER_FMO_TOUR } from '../../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForecastingMigrationModal = () => {
  const {
    tour
  } = useContext(TourContext);
  const [isOpen, handleClose] = useOverviewModal(setHasSeenFmoAdminMigrationTour());
  const handleClick = useCallback(() => {
    handleClose(START_EXISTING_USER_FMO_TOUR);
    tour.start(EXISTING_USER_FMO_TOUR);
  }, [handleClose, tour]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 788,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      className: "m-bottom-8",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.existing.forecastMigrationModal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => handleClose(SKIP_EXISTING_USER_FMO_TOUR)
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        gap: "1400",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-200",
          marginBlockEnd: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "tour.existing.forecastMigrationModal.body"
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          marginBlockEnd: "400",
          name: "forecasting",
          width: 200
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "tour.existing.forecastMigrationModal.startTour"
          })
        })]
      })
    })]
  });
};
export default ForecastingMigrationModal;